// extracted by mini-css-extract-plugin
export var orderSummary = "_pm-0";
export var showMoreLessButton = "_pm-1";